import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {Link, useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {
    ThinAddIcon, ThinClassIcon,
    ThinCloseIcon,
    ThinCreditScoreIcon,
    ThinInfoIcon,
    ThinPrintIcon,
    ThinSpecialIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {RemoveModal} from "../../../components/template/remove-modal";
import {AdminsPickAllowedForExtraPaymentModal} from "./pick-allowed";
import {SelectClassModal} from "../classes/select-class-modal";

interface paidInterface {
    id: number,
    studentID: number,
    name: string,
    paidAt: string,
    paidPrice: number,
    class: string,
}

interface allowedInterface {
    studentId: number,
    name: string,
}

export const AdminsExtraPaymentViewScreen = () => {
    const {paymentId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        title: '',
        forAll: false,
        class: '',
        price: 0,
        expiresAt: '2000-01-01 00:00:00',
        createdAt: '2000-01-01 00:00:00',
        paid: [] as paidInterface[],
        allowed: [] as allowedInterface[],
        specialIds: [] as number[],
        optional:false,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/extra/get',
            {
                id: paymentId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                title: string,
                forAll: 0 | 1,
                class: string,
                price: number,
                expiresAt: string,
                createdAt: string,
                paid: paidInterface[] | null,
                allowed: allowedInterface[] | null,
                optional:0|1,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let lst: number[] = [];
                if (d.allowed !== null)
                    d.allowed.forEach(e => {
                        lst.push(e.studentId);
                    });
                document.title = `${d.title} | پرداخت متفرقه | اتوماسیون شهاب`;
                setData({
                    loaded: true,
                    title: d.title,
                    forAll: d.forAll === 1,
                    class: d.class,
                    price: d.price,
                    expiresAt: d.expiresAt,
                    createdAt: d.createdAt,
                    paid: d.paid === null ? [] : d.paid,
                    allowed: d.allowed === null ? [] : d.allowed,
                    specialIds: lst,
                    optional: d.optional === 1,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [tab, setTab] = useState('info' as 'info' | 'allowed' | 'paid');
    const [pickStudentsAllowed, setPickStudentsAllowed] = useState(false);
    const [removeAllowedStudent, setRemoveAllowedStudent] = useState({
        show: false,
        id: 0,
        name: '',
    });
    const [classSelected, setClassSelected] = useState({
        id: 0,
        title: '',
    });
    const [classModal, setClassModal] = useState(false);
    const fetchPayments = (classId: number, classTitle: string) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/extra/print',
            {
                id: paymentId as string,
                class: classId.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: paidInterface[] | null,
                title: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setClassSelected({
                    title: classTitle,
                    id: classId,
                });
                setData(v => {
                    let x = {...v};
                    x.paid = d.list === null ? [] : d.list;
                    return x;
                });
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'پرداخت‌های متفرقه', url: '/admins/extra'},
                {title: data.loaded ? data.title : '...', url: `/admins/extra/view/${paymentId}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="d-none d-lg-block" style={{height: 60}}/>
                                <div className="student-profile">
                                    <b>{data.title}</b>
                                    <span>{data.forAll ? 'همگانی' : (data.class === '' ? 'افراد خاص' : `کلاس ${data.class}`)}</span>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="open-tabbar" style={{marginTop: 20}}>
                                    <div className="open-tabbar-inner">
                                        <button onClick={() => {
                                            setTab('info');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'info' ? 'active' : ''}>
                                            <ThinInfoIcon/>
                                            مشخصات
                                        </button>
                                        <button onClick={() => {
                                            setTab('allowed');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'allowed' ? 'active' : ''}>
                                            <ThinSpecialIcon/>
                                            افراد مجاز
                                        </button>
                                        <button onClick={() => {
                                            setTab('paid');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'paid' ? 'active' : ''}>
                                            <ThinCreditScoreIcon/>
                                            پرداخت‌ها
                                        </button>
                                    </div>
                                </div>
                                {
                                    tab === 'info' ?
                                        <div className="screen-card">
                                            <div className="screen-card-header">
                                                <b>مشخصات پرداخت متفرقه</b>
                                            </div>
                                            <div className="student-info">
                                                <span>عنوان:</span>
                                                <b>{data.title}</b>
                                                <span>قیمت:</span>
                                                {
                                                    !data.optional ?
                                                        <b>{CurrencyFormat(data.price)} تومان</b> :
                                                        <b>هزینه انتخابی</b>
                                                }
                                                <span>تاریخ پایان:</span>
                                                <b>{StringDigitsConvertToPersian(data.expiresAt.split(' ')[1] + " " + GregorianToPersian(data.expiresAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                                <span>تاریخ ایجاد:</span>
                                                <b>{StringDigitsConvertToPersian(data.createdAt.split(' ')[1] + " " + GregorianToPersian(data.createdAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                            </div>
                                        </div> :
                                        (
                                            tab === 'allowed' ?
                                                <div className={"screen-card"}>
                                                    <div className="screen-card-header">
                                                        <b>افراد خاص مجاز پرداخت</b>
                                                        <button onClick={() => setPickStudentsAllowed(true)}>
                                                            <ThinAddIcon/>
                                                            <span>افزودن</span>
                                                        </button>
                                                    </div>
                                                    <table
                                                        className="table open-table table-striped table-hover table-bordered">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>دانش‌آموز</th>
                                                            <th>امکانات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            data.allowed.map((s, i) =>
                                                                <tr key={"SSx38dfkEEfJv8" + i}>
                                                                    <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                    <td>
                                                                        <Link
                                                                            to={`/admins/students/view/${s.studentId}`}>
                                                                            {s.name}
                                                                        </Link>
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            onClick={() => setRemoveAllowedStudent({
                                                                                show: true,
                                                                                id: s.studentId,
                                                                                name: s.name,
                                                                            })} className={"open-tooltip"}>
                                                                            <ThinCloseIcon/>
                                                                            <i>حذف</i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div> :
                                                <div className={"screen-card"}>
                                                    <div className="screen-card-header">
                                                        <b>پرداخت های موفق</b>
                                                        <div className="d-inline-flex align-items-center"
                                                             style={{gap: 10}}>
                                                            <button onClick={() => {
                                                                const _class = {...classSelected};
                                                                window.open(`/print/admins/extra/${paymentId}/${_class.id}`);
                                                            }}>
                                                                <ThinPrintIcon/>
                                                                <span>پرینت</span>
                                                            </button>
                                                            <button onClick={() => setClassModal(true)}>
                                                                <ThinClassIcon/>
                                                                <span>{classSelected.id > 0 ? classSelected.title : 'همه کلاس‌ها'}</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <table
                                                        className="table open-table table-striped table-hover table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>دانش‌آموز</th>
                                                            <th>کلاس</th>
                                                            <th>مبلغ پرداختی</th>
                                                            <th>تاریخ</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            data.paid.map((s, i) =>
                                                                <tr key={"K29jj39fFFFi8DD" + i}>
                                                                    <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                    <td>
                                                                        <Link
                                                                            to={`/admins/students/view/${s.studentID}`}>
                                                                            {s.name}
                                                                        </Link>
                                                                    </td>
                                                                    <td>{s.class === '' ? '-' : s.class}</td>
                                                                    <td>
                                                                        <span>{CurrencyFormat(s.paidPrice)}<TomansIcon/></span>
                                                                    </td>
                                                                    <td>
                                                                        {StringDigitsConvertToPersian(s.paidAt.split(' ')[1] + " " + GregorianToPersian(s.paidAt.split(' ')[0]).replaceAll('-', '/'))}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                        )
                                }
                            </div>
                        </div>
                    </div> : null
            }
            <RemoveModal
                active={removeAllowedStudent.show}
                closeHandler={() => setRemoveAllowedStudent(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"غیرمجاز سازی دانش‌آموز"}
                desc={"آیا مطمئن هستید می‌خواهید " + removeAllowedStudent.name + " را از لیست دانش‌آموزان مجاز به این پرداخت حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeAllowedStudent};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/extra/allowed/toggle',
                        {
                            paymentId: paymentId as string,
                            studentId: x.id.toString(),
                            allow: '0',
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'دانش‌آموز مورد نظر از لیست مجاز‌ها حذف شد.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
            <AdminsPickAllowedForExtraPaymentModal
                active={pickStudentsAllowed}
                closeHandler={() => {
                    setPickStudentsAllowed(false);
                    ShowProgressLoading();
                    fetchData();
                }}
                paymentId={paymentId as string}
                specialList={data.specialIds}
                onDone={() => {
                    fetchData();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
            />
            <SelectClassModal
                active={classModal}
                closeHandler={() => setClassModal(false)}
                onSelected={(id: number, title: string) => {
                    // ShowProgressLoading();
                    setClassSelected({
                        title: "کلاس " + title,
                        id: id,
                    });
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchPayments(id, title);
                }}
            />
        </>
    );
};